import { useQual } from 'hooks';
import { Address } from 'types';

// Note: as long as we have this "qual" object, we should
// keep the address split between its individual parts.
// Because we need to mutate this qual, and because it also
// gets stored in localStorage cache for the lifetime of the session,
// we're going to need to translate it back and forth *somewhere*.
// Strong opinion: we should keep the qual object "clean" so it's
// a single source of truth.  Otherwise we're going to expose
// ourselves to state issues when the address in the qual object
// deviates from the address object somewhere else in memory or
// localStorage.
//
// Field name discrepancies between Qual and Address/GraphQL:
//
// `apartment` vs `unit`: `apartment` is a legacy alias that some microsites still pass
// in the URL qual param. It is fully normalized to `unit` at ingestion in qualify.tsx
// and does not exist anywhere else internally — always read `unit`.
//
// `zip` vs `postalCode`: unlike `apartment`, `zip` is still the live internal field
// name used throughout the Qual object and store. This hook translates it to the
// canonical `postalCode` name used by GraphQL and backend services, but the Qual
// itself continues to use `zip`.
export function useAddress(): Address {
  const qualData = useQual();
  const { street, unit, city, state, zip, line2Type } = {
    ...qualData,
  };

  const address = {
    street,
    unit,
    city,
    state,
    postalCode: zip,
    line2Type,
  } as Address;
  return address;
}
